import { Component, OnInit } from "@angular/core";
import { GoogleAnalyticsService } from "../../services/google-analytics.service";

@Component({
  selector: "app-ga-consent-dialog",
  templateUrl: "./ga-consent-dialog.component.html",
  styleUrls: ["./ga-consent-dialog.component.scss"],
})
export class GaConsentDialogComponent implements OnInit {

  isVisible = false

  ngAfterViewInit() {
    setTimeout(() => {
      this.isVisible = true
    }, 2000)
  }

  constructor(
    private _googleAnalyticsService : GoogleAnalyticsService,
  ) {

  }

  ngOnInit() {
    this.toShowDialog = this._googleAnalyticsService.haveConsent() === null
  }

  toShowDialog = true

  aceitar() {
    this._googleAnalyticsService.defineConsent('granted');
    this.toShowDialog = false
  }

  rejeitar() {
    this._googleAnalyticsService.defineConsent('denied');
    this.toShowDialog = false
  }

}
